import { render, staticRenderFns } from "./StepsBlock.vue?vue&type=template&id=798adc36&"
import script from "./StepsBlock.vue?vue&type=script&lang=js&"
export * from "./StepsBlock.vue?vue&type=script&lang=js&"
import style0 from "./StepsBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports